module.exports = __webpack_public_path__ + "static/media/footer-brend.405222a1.svg";